module.exports = __webpack_public_path__ + "static/media/phone-home.ed94011c.svg";